











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MoodCard extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: "" }) private imageUrl!: string;
  @Prop({ default: "" }) private linkUrl!: string;

  handleClick() {
    this.$router.push({ path: "/esperienze", query: { mood: this.linkUrl } });
  }
}
